module.exports = __webpack_public_path__ + "static/media/arrow-down.d0d8eb43.svg";